<app-viz-thumbnail-container [size]='size' [title]='title'>
    <div *ngIf="data" class='img' #thumbnail></div>
</app-viz-thumbnail-container>